var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-overview" },
    [
      _c(
        "el-row",
        { staticClass: "action-wrapper" },
        [
          _vm.taskForm.type === "spider"
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-position"
                  },
                  on: { click: _vm.onNavigateToSpider }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Navigate to Spider")) + " ")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: {
                type: "warning",
                size: "small",
                icon: "el-icon-position"
              },
              on: { click: _vm.onNavigateToNode }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Navigate to Node")) + " ")]
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "content" },
        [
          _c(
            "el-col",
            { staticStyle: { "padding-right": "20px" }, attrs: { span: 12 } },
            [
              _c(
                "el-row",
                { staticClass: "task-info-overview-wrapper wrapper" },
                [
                  _c("h4", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("Task Info")))
                  ]),
                  _c("task-info-view", {
                    on: {
                      "click-log": function() {
                        return _vm.$emit("click-log")
                      }
                    }
                  })
                ],
                1
              ),
              _c("el-row", {
                staticStyle: {
                  "border-bottom": "1px solid #e4e7ed",
                  margin: "0 0 20px 0",
                  "padding-bottom": "20px"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.taskForm.type === "spider"
                ? _c(
                    "el-row",
                    { staticClass: "task-info-spider-wrapper wrapper" },
                    [
                      _c(
                        "h4",
                        {
                          staticClass: "title spider-title",
                          on: { click: _vm.onNavigateToSpider }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-search",
                            staticStyle: { "margin-right": "5px" }
                          }),
                          _vm._v(" " + _vm._s(_vm.$t("Spider Info")))
                        ]
                      ),
                      _c("spider-info-view", { attrs: { "is-view": true } })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { staticClass: "task-info-node-wrapper wrapper" },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "title node-title",
                      on: { click: _vm.onNavigateToNode }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-search",
                        staticStyle: { "margin-right": "5px" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("Node Info")))
                    ]
                  ),
                  _c("node-info-view", { attrs: { "is-view": true } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }